import { useState } from 'react';
import { useNavigate } from 'react-router-dom'

import { Button, TextField } from '@mui/material';
import { Bounce, ToastContainer, toast } from 'react-toastify';

import './Login.css';
import 'react-toastify/dist/ReactToastify.css';
import { AuthService } from '../../services/AuthService';
import BasicCard from '../../components/card/Card';

import image4 from '../../assets/logo2.jpg';
import { mostraMensagemErro, mostraMensagemSucesso } from '../../helpers/Notificacoes';

function ResetSenha() {

  const authService = new AuthService();
  const navigate = useNavigate();

  const [user, setUser] = useState('');

  async function Voltar () {
    navigate("/")
  }

  async function solicitaEmailReset() {
    const resposta = await authService.redefinirSenha(
      {
        email: user
      },
      "/v1/auth/reset"
    ).then((response) => {
      return response;
    })
      .catch((error) => {
        return error;
      });

      if (resposta.codigo !== 200) {
        await mostraMensagemErro(resposta.mensagem || "Erro ao solicitar nova senha");
        setUser('');
        
      } else {
        await mostraMensagemSucesso('Solicitação realizada, verifique o email enviado.');
      }
      setTimeout(() => {
        navigate("/");
      }, 5000);
  }

  return (
    <div className="Login">
      <div className="LoginBottom">
        <BasicCard>
          <div className="logo-container">
            <img
              src={image4}
              alt="Logo"
              style={{ width: 200, height: 80 }}
            />
          </div>
          <TextField
            className="fields"
            required
            id="filled-required"
            label="E-mail"
            variant="outlined"
            value={user}
            onChange={(e) => setUser(e.target.value.toLowerCase())}
            sx={{ marginBottom: 2 }}
            autoFocus
          />
          <div className='ContainerBotoes'>
          <Button
              variant="contained"
              onClick={Voltar}
              sx={{
                width: { xs: '100%', sm: '50%', md: '40%' },
                maxWidth: 200,
                backgroundColor: '#5693B9',               
              }}
            >
              Voltar
            </Button>
            <Button
              variant="contained"
              onClick={solicitaEmailReset}
              sx={{
                width: { xs: '100%', sm: '50%', md: '40%' },
                maxWidth: 200,
                backgroundColor: '#5693B9',
                marginLeft:4
              }}
            >
              Enviar Link
            </Button>
           
          </div>
          <ToastContainer />
        </BasicCard>
      </div>
    </div>
  );
}

export default ResetSenha;